import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-778e75a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-h6" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h7" }, "Substâncias", -1))
const _hoisted_3 = { class: "row full-width" }

import { Category } from '@/models/category';
import { FormRules } from '@/utils';
import { Formula } from '@/models/formula';
import { FormulaSubstance } from '@/models/formula-substance';
import { plainToInstance } from 'class-transformer';
import { Substance } from '@/models/substance';
import { computed, ref } from 'vue';
import { FormulaForm, getEmptyFormulaForm, getFormByInstance } from '../models/formula-form';
import QForm from 'quasar/src/components/form/QForm.js';import useQuasar from 'quasar/src/composables/use-quasar.js';;

interface Props {
  categories: Category[];
  substances: Substance[];
  formula?: Formula | null;
}

interface Emits {
  (e: 'cancel'): void;
  (e: 'save', formData: FormulaForm): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    categories: null,
    substances: null,
    formula: null
  },
  emits: ["cancel", "save"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'cancel'): void;
  (e: 'save', formData: FormulaForm): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  categories: Category[];
  substances: Substance[];
  formula?: Formula | null;
}




const quasar = useQuasar();

const formData = ref<FormulaForm>(getEmptyFormulaForm());

const form = ref<InstanceType<typeof QForm> | null>(null);

const isEdit = computed(() => props.formula !== undefined && props.formula !== null);

const categoriesOptions = computed(() =>
  props.categories.map((category) => ({ label: category.name, value: category.id }))
);

const getSubstanceLabel = (formulaSubstance: FormulaSubstance) => {
  return formulaSubstance.substance?.code === formulaSubstance.substance?.utf8Code
    ? `${formulaSubstance.substance?.utf8Code}`
    : `${formulaSubstance.substance?.utf8Code} (${formulaSubstance.substance?.code})`;
};

const resetForm = () => {
  formData.value = getEmptyFormulaForm();
};

const save = () => {
  form.value?.validate().then((success) => {
    if (success) {
      emit('save', formData.value);
    } else {
      quasar.notify({
        type: 'warning',
        message: 'Por favor confira os campos obrigatórios.',
      });
    }
  });
};

const cancel = () => {
  emit('cancel');
  resetForm();
};

const setFormula = (formula: Formula | null) => {
  if (formula !== null) {
    formData.value = getFormByInstance(formula);
  } else {
    resetForm();
  }
};

const setSubstances = () => {
  if (props.substances.length > 0) {
    props.substances.forEach((substance) => {
      if (formData.value.formulaSubstances.findIndex((el) => el.id === substance.id) === -1) {
        formData.value.formulaSubstances.push(
          plainToInstance(FormulaSubstance, {
            formula_id: 0,
            substance_id: substance.id,
            value: 0,
            substance,
          })
        );
      }
    });
  }
};

expose({ resetForm, setFormula, setSubstances });

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!

  return (_openBlock(), _createBlock(_unref(QForm), {
    ref_key: "form",
    ref: form,
    class: "ni-form q-gutter-md",
    onSubmit: save,
    autofocus: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(isEdit) ? 'Editar Fórmula' : 'Cadastrar Fórmula'), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_q_card_section, { class: "q-pt-none q-gutter-sm" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_input, {
            outlined: "",
            modelValue: formData.value.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
            label: "Nome",
            "lazy-rules": "",
            rules: [_unref(FormRules).required]
          }, null, 8, ["modelValue", "rules"]),
          _createVNode(_component_q_input, {
            outlined: "",
            modelValue: formData.value.description,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.description) = $event)),
            label: "Descrição",
            "lazy-rules": "",
            type: "textarea",
            autogrow: "",
            class: "q-mb-lg"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_q_select, {
            outlined: "",
            clearable: "",
            modelValue: formData.value.categoryId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.categoryId) = $event)),
            label: "Categoria",
            options: _unref(categoriesOptions),
            "map-options": "",
            "emit-value": "",
            "lazy-rules": "",
            rules: [_unref(FormRules).required]
          }, null, 8, ["modelValue", "options", "rules"])
        ]),
        _: 1
      }),
      _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.formulaSubstances, (substance, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-6",
                key: index
              }, [
                _createVNode(_component_q_input, {
                  outlined: "",
                  class: "q-ma-xs",
                  type: "number",
                  modelValue: formData.value.formulaSubstances[index].value,
                  "onUpdate:modelValue": ($event: any) => ((formData.value.formulaSubstances[index].value) = $event),
                  label: getSubstanceLabel(substance),
                  "lazy-rules": ""
                }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_q_card_actions, { align: "right" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_btn, {
            flat: "",
            label: "Cancelar",
            onClick: cancel
          }),
          _createVNode(_component_q_btn, {
            type: "submit",
            color: "primary",
            label: "Salvar"
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})